// Clear store
export const clear_store = "CLEAR_STORE";

// Получение данных для заключения
export const fetch_Signal_Request = "FETCH_SIGNAL_REQUEST";
export const fetch_repData_Success = "FETCH_REPORT_DATA_SUCCESS";
export const change_repData = "CHANGE_REPORTDATA";

// Preview medical conclusion
export const preview_MedicalConclusion_Request = "PREVIEW_MEDICALCONCLUSION_REQUEST";
export const fetch_RRHR_QTcAlg_Success = " FETCH_RRHR_QTCALG_SUCCESS";

export const fetch_data_Request = "FETCH_DATA_REQUEST";
export const fetch_data_Failure = "FETCH_DATA_FAILURE";
export const fetch_data_Success = "FETCH_DATA_SUCCESS";

// Модальные окна
export const open_modal = "OPEN_MODAL";
export const close_modal = "CLOSE_MODAL";
export const open_modal_withmode = "SET_MODAL_WITHMODE";
export const modal_mode_fullscreen = "MODALMODE_FULLSCREEN";
export const modal_mode_halfscreen = "MODALMODE_HALFSCREEN";

// Настройки приложения
export const change_Lang = "CHANGE_LANGUAGE";
export const change_Theme = "CHANGE_THEME";
export const change_RhGraph = "CHANGE_RHYTHMGRAPH_SETTINGS";
export const change_12Graph = "CHANGE_12LEADGRAPH_SETTINGS";
export const change_measurer_ECG12Graph = "CHANGE_MEASURER_ECG12GRAPH";
export const change_ReprCmpxGraph = "CHANGE_REPRCMPXGRAPH_SETTINGS";
export const change_selectorGraph = "CHANGE_SELECTORXGRAPH_SETTINGS";
export const change_SignalFilters = "CHANGE_SIGNALFILTERS_SETTINGS";
export const change_ReportSettings = "CHANGE_REPORT_SETTINGS";
export const change_wholegraph = "CHANGE_WHOLEGRAPH_SETTINGS";
export const reset_graphSettings = "RESET_GRAPH_SETTINGS";

// Запорc на сохранение данных на сервере
export const save_data_Request = "SAVE_DATA_REQUEST";
export const save_data_Failure = "SAVE_DATA_FAILURE";
export const save_data_Success = "SAVE_DATA_SUCCESS";
export const save_data_prepare = "SAVE_DATA_PREPARE";

// Запрос на смену представительного комплекса
export const change_representativeCmpx_Request = "CHANGE_REPRESENTATIVE_CMPX_REQUEST";
export const change_representativeCmpx_Success = "CHANGE_REPRESENTATIVE_CMPX_SUCCESS";
export const change_representativeCmpx_Failure = "CHANGE_REPRESENTATIVE_CMPX_FAILURE";

// Запрос на установку стимуляотра
export const set_stimulator_Request = "SET_STIMUALTOR_REQUEST";
export const set_stimulator_Success = "SET_STIMUALTOR_SUCCESS";
export const set_stimulator_Failure = "SET_STIMUALTOR_FAILURE";

// Подпись заключения
export const sign_Report_Request = "SIGN_REPORT_REQUEST";
export const sign_Report_Failure = "SIGN_REPORT_FAILURE";
export const sign_Report_Success = "SIGN_REPORT_SUCCESS";

export const verificate_CmpxIntervals = "VERIFICATE_CMPXINTERVALS";

export const remove_Info = "CLOSE_INFO";
export const remove_InfoGroup = "CLOSE_INFOGROUP";
export const add_Info = "ADD_INFO";

// Константы для формирования информационных сообщений (панелек с результатом выполнения операций)
export const _info_group_SaveData = "SAVE_DATA";
export const _info_group_Sign = "SIGN";
export const _info_group_ChangeCmpx = "CHANGE_REPRCMPX";
export const _info_group_SetStimulator = "SET_STIMULATOR";
export const _info_type_success = "SUCCES";
export const _info_type_error = "ERROR";

// Константы состояния параметров заключения
export const _param_edited = "edited";
export const _param_origignal = "original";
export const _param_default = "default";

// Константы типы всплывающих панелей
export const _infopanel_success = "infopanel_success";
export const _infopanel_error = "infopanel_error";
